/**
 * The error page's picture: RowCall's mark after a bad day. Its three bars have toppled over, the line beside them has
 * snapped in two, and a few sparks fly from the break. Theme colours only; the bars wobble once as it appears.
 */
export const DroppedCallArt = () => (
  <svg viewBox="0 0 160 96" aria-hidden="true" className="h-24 w-40 text-primary">
    {/* The floor. */}
    <line
      x1="8"
      y1="84"
      x2="152"
      y2="84"
      stroke="currentColor"
      strokeOpacity="0.15"
      strokeWidth="2"
      strokeLinecap="round"
    />
    {/* The bars, fallen this way and that. */}
    <g className="origin-bottom motion-safe:animate-in motion-safe:spin-in-6 motion-safe:duration-500">
      <rect x="14" y="70" width="34" height="10" rx="5" fill="currentColor" transform="rotate(-6 31 75)" />
      <rect x="22" y="56" width="48" height="10" rx="5" fill="currentColor" transform="rotate(8 46 61)" />
      <rect
        x="44"
        y="72"
        width="22"
        height="10"
        rx="5"
        fill="currentColor"
        fillOpacity="0.7"
        transform="rotate(-14 55 77)"
      />
    </g>
    {/* The line, snapped. */}
    <line x1="88" y1="44" x2="110" y2="40" stroke="currentColor" strokeWidth="9" strokeLinecap="round" />
    <line x1="124" y1="48" x2="146" y2="58" stroke="currentColor" strokeWidth="9" strokeLinecap="round" />
    {/* Sparks from the break. */}
    <g className="text-destructive motion-safe:animate-pulse">
      <line x1="117" y1="30" x2="117" y2="22" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <line x1="109" y1="27" x2="104" y2="21" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <line x1="125" y1="27" x2="130" y2="21" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </g>
  </svg>
)
